import type { CostBasis } from '../../types/costBasis'
import { createTransactionsByTradeAction } from './createTransactionsByTradeAction'
import type {
  CreateTransactionsByCategoryActionParameters,
  CreateTransactionsByCategoryActionReturnTypes,
} from './types'

type CreateTransactionsByLiquidationActionParameters =
  CreateTransactionsByCategoryActionParameters & {
    readonly costBasis: CostBasis
    readonly handleLoanAsTrade?: boolean
    readonly use5PercentRule?: boolean
  }

type CreateTransactionsByLiquidationActionReturnTypes =
  CreateTransactionsByCategoryActionReturnTypes

export const createTransactionsByLiquidationAction = ({
  actionId,
  action,
  loans,
  crossActionBundles,
  assetBalances,
  assetBorrows,
  usedBalances,
  nftAcquiredTimestamps,
  costBasis,
  isLocked = false,
  handleLoanAsTrade = false,
  use5PercentRule = false,
}: CreateTransactionsByLiquidationActionParameters): CreateTransactionsByLiquidationActionReturnTypes => {
  // locked action の場合処理しない
  if (isLocked) {
    return {
      transactions: [],
      loans,
      crossActionBundles,
      assetBalances,
      assetBorrows,
      usedBalances,
    }
  }

  if (handleLoanAsTrade) {
    return createTransactionsByTradeAction({
      actionId,
      action,
      loans,
      crossActionBundles,
      assetBalances,
      assetBorrows,
      usedBalances,
      nftAcquiredTimestamps,
      isLocked,
      costBasis,
      use5PercentRule,
    })
  }

  if (action.loanId === undefined) {
    action.loanId = ''
  }

  // TODO 一時的にコメントアウトして、未実装エラーを投げる
  throw new Error('Not implemented yet')
  // // merge transfers
  // const mergedTransfers = mergeActionTransfers(action.transfers)
  // const handleBondResult = replaceBondOfTransfers({
  //   actionId,
  //   timestamp: action.timestamp,
  //   transfers: mergedTransfers,
  //   loans,
  //   assetBalances,
  //   assetBorrows,
  //   usedBalances,
  // })
  // const newLoans = handleBondResult.loans
  // let newAssetBalances = handleBondResult.assetBalances
  // let newAssetBorrows = handleBondResult.assetBorrows
  // let newUsedBalances = handleBondResult.usedBalances
  // const transactions: Transaction[] = [...handleBondResult.transactions]
  // const transfers = handleBondResult.transfers
  // const transferCount: { all: number; in: number; out: number } = {
  //   all: 0,
  //   in: 0,
  //   out: 0,
  // }
  // const inTransfers: Transfer[] = []
  // const outTransfers: Transfer[] = []
  // for (const transfer of transfers) {
  //   transferCount.all += 1
  //   if (transfer.direction === 'in') {
  //     transferCount.in += 1
  //     inTransfers.push(transfer)
  //   }
  //   if (transfer.direction === 'out') {
  //     transferCount.out += 1
  //     outTransfers.push(transfer)
  //   }
  // }

  // // update loan
  // const loan = newLoans.get(action.loanId) ?? {
  //   id: action.loanId,
  //   borrows: [],
  //   lends: [],
  // }
  // const withdrawTransfers: Transfer[] = []
  // const repaymentTransfers: Transfer[] = []
  // for (const borrow of loan.borrows) {
  //   if (borrow.amount.value === 0n) {
  //     continue
  //   }
  //   repaymentTransfers.push({
  //     direction: 'out',
  //     asset: createAssetByAssetKey(borrow.asset),
  //     amount: borrow.amount,
  //   })
  // }
  // for (const lend of loan.lends) {
  //   for (const position of lend.positions) {
  //     if (position.amount.value === 0n) {
  //       continue
  //     }
  //     withdrawTransfers.push({
  //       direction: 'in',
  //       asset: createAssetByAssetKey(position.asset),
  //       amount: position.amount,
  //     })
  //   }
  //   if (lend.bond !== undefined && lend.bond.amount.value !== 0n) {
  //     repaymentTransfers.push({
  //       direction: 'out',
  //       asset: createAssetByAssetKey(lend.bond.asset),
  //       amount: lend.bond.amount,
  //     })
  //   }
  // }
  // newLoans.delete(action.loanId)

  // for (const transfer of withdrawTransfers) {
  //   const withdrawResult = createWithdrawTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //   })
  //   transactions.push(withdrawResult.transaction)
  //   newAssetBalances = withdrawResult.assetBalances
  //   newAssetBorrows = withdrawResult.assetBorrows
  //   newUsedBalances = withdrawResult.usedBalances

  //   const insufficientResult = createInsufficientTransactionByTransfer({
  //     actionId,
  //     timestamp: action.timestamp,
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //   })
  //   if (insufficientResult !== undefined) {
  //     transactions.push(insufficientResult.transaction)
  //     newAssetBalances = insufficientResult.assetBalances
  //     newAssetBorrows = insufficientResult.assetBorrows
  //     newUsedBalances = insufficientResult.usedBalances
  //   }

  //   const feeResult = createFeeTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     subCategory: 'liquidation-loss',
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //     use5PercentRule,
  //   })
  //   transactions.push(feeResult.transaction)
  //   newAssetBalances = feeResult.assetBalances
  //   newAssetBorrows = feeResult.assetBorrows
  //   newUsedBalances = feeResult.usedBalances
  // }

  // for (const transfer of repaymentTransfers) {
  //   const insufficientResult = createInsufficientTransactionByTransfer({
  //     actionId,
  //     timestamp: action.timestamp,
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //     onlyUseBorrows: true,
  //   })
  //   if (insufficientResult !== undefined) {
  //     transactions.push(insufficientResult.transaction)
  //     newAssetBalances = insufficientResult.assetBalances
  //     newAssetBorrows = insufficientResult.assetBorrows
  //     newUsedBalances = insufficientResult.usedBalances
  //   }

  //   const repaymentResult = createRepaymentTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //   })
  //   transactions.push(repaymentResult.transaction)
  //   newAssetBalances = repaymentResult.assetBalances
  //   newAssetBorrows = repaymentResult.assetBorrows
  //   newUsedBalances = repaymentResult.usedBalances

  //   const incomeResult = createIncomeTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     subCategory: 'liquidation-profit',
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //   })
  //   transactions.push(incomeResult.transaction)
  //   newAssetBalances = incomeResult.assetBalances
  //   newAssetBorrows = incomeResult.assetBorrows
  //   newUsedBalances = incomeResult.usedBalances
  // }

  // for (const transfer of inTransfers) {
  //   const result = createIncomeTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     subCategory: 'other-income',
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //   })
  //   transactions.push(result.transaction)
  //   newAssetBalances = result.assetBalances
  //   newAssetBorrows = result.assetBorrows
  //   newUsedBalances = result.usedBalances
  // }

  // for (const transfer of outTransfers) {
  //   const insufficientResult = createInsufficientTransactionByTransfer({
  //     actionId,
  //     timestamp: action.timestamp,
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //   })
  //   if (insufficientResult !== undefined) {
  //     transactions.push(insufficientResult.transaction)
  //     newAssetBalances = insufficientResult.assetBalances
  //     newAssetBorrows = insufficientResult.assetBorrows
  //     newUsedBalances = insufficientResult.usedBalances
  //   }

  //   const feeResult = createFeeTransaction({
  //     actionId,
  //     timestamp: action.timestamp,
  //     subCategory: 'other-fee',
  //     transfer,
  //     assetBalances: newAssetBalances,
  //     assetBorrows: newAssetBorrows,
  //     usedBalances: newUsedBalances,
  //     costBasis,
  //     use5PercentRule,
  //   })
  //   transactions.push(feeResult.transaction)
  //   newAssetBalances = feeResult.assetBalances
  //   newAssetBorrows = feeResult.assetBorrows
  //   newUsedBalances = feeResult.usedBalances
  // }

  // return {
  //   transactions,
  //   loans: newLoans,
  //   crossActionBundles,
  //   assetBalances: newAssetBalances,
  //   assetBorrows: newAssetBorrows,
  //   usedBalances: newUsedBalances,
  // }
}

// const createAssetByAssetKey = (
//   assetKey: string,
// ): CryptoCurrency | FiatCurrency | Nft => {
//   const [type, id] = assetKey.split('/')
//   switch (type) {
//     case 'CryptoCurrency': {
//       return {
//         symbol: '',
//         type,
//         id,
//         name: '',
//         updatedAt: 0,
//       }
//     }
//     case 'FiatCurrency': {
//       return {
//         symbol: '',
//         type,
//         id: id as FiatCurrency['id'],
//         name: '',
//       }
//     }
//     case 'Nft': {
//       return {
//         type,
//         id,
//         updatedAt: 0,
//       }
//     }
//     default: {
//       throw new Error(`Invalid assetKey: ${assetKey}`)
//     }
//   }
// }
